import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import AssignedSurveyDialog, {
  AssignedSurveyDialogCallbackInput,
  AssignedSurveyDialogUniqueProps,
} from '../AssignedSurveyDialog';

const { useDialogForContext, useDialog: useAssignedSurveyDialog } =
  getDialogHooks<
    AssignedSurveyDialogUniqueProps,
    AssignedSurveyDialogCallbackInput
  >(AssignedSurveyDialog);
export const useAssignedSurveyDialogForContext = useDialogForContext;
export default useAssignedSurveyDialog;
